import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PasswordService extends BaseService{

  constructor(http:HttpClient) {
    super(http)
  }

  getUrl(): string {
    return "api/wechat-config/name?_allow_anonymous=true";
  }
  //通过手机号  获取验证码
  getCode(tel){
    const url = `api/sms/login-sms/${tel}`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object id=${tel}`)),
      catchError(this.handleError<any>(`getany id=${tel}`))
    )
  }
  // 获取人员信息
  userInfo(): Observable<any> {
    const url = `api/person/current`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log('current')),
      catchError(this.handleError<any>('current')),
    );
  }
  // 获取当前供应商的状态
  supplierState(): Observable<any> {
    const url = `api/sup-gui/find-by-login`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log('current')),
      catchError(this.handleError<any>('current')),
    );
  }

  textCode(){
    const url = `api/sms/login-sms/$(tel)`;

  }
}
